import React, { createContext, ReactNode, Reducer, useContext, useReducer } from 'react';
import { InitializationData } from '../../global-types';
import { initialDataState } from './data-context-state';
import { actionTypes, CreateContextProps, DataActions, InitializationDataContextState } from './data-context-types';

export const InitializationDataContext = createContext<CreateContextProps>(undefined);

const reducer: Reducer<InitializationDataContextState, DataActions> = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_INIT_DATA:
      return {
        ...state,
        data: action.payload,
      };
    case actionTypes.SET_FONTS:
      return {
        ...state,
        fonts: action.payload,
      };
    case actionTypes.UPDATE_FONT_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case actionTypes.SET_LINE_ITEM_UUID:
      return {
        ...state,
        lineItemUUID: action.payload,
      };
    case actionTypes.UPDATE_PROJECT_NAME:
      return {
        ...state,
        data: {
          ...(state.data as InitializationData),
          name: action.payload,
        },
      };
    case actionTypes.RESET_DATA_CONTEXT:
      return initialDataState;
    case actionTypes.SET_MEMBERSHIP_STATUS:
      return {
        ...state,
        membershipStatus: action.payload,
      };

    default:
      throw new Error(`Unhandled action type in init-data-context`);
  }
};

export const InitializationDataContextProvider = ({ children }: { children: ReactNode }) => {
  const [initializedDataState, initializationDataDispatch] = useReducer(reducer, initialDataState);
  return (
    <InitializationDataContext.Provider value={{ initializedDataState, initializationDataDispatch }}>
      {children}
    </InitializationDataContext.Provider>
  );
};

// Hooks
export const useInitializationDataContext = () => {
  const context = useContext(InitializationDataContext);
  if (context === undefined) {
    throw new Error('useInitDataContext must be used within InitializationDataContext');
  }

  return context;
};
